module.exports = __webpack_public_path__ + "static/media/table_column_reorder.860764b5.png";